import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { DigitalCard } from '../components/carte/DigitalCard';
import { FamilySection } from '../components/carte/FamilySection';
import { PetsSection } from '../components/carte/PetsSection';
import { ConsentDialog, EditCardDialog } from '../components/carte/EditCardDialog';
import type { FamilyMember } from '../data/carte';
export function MaCarte() {
  const [memberId, setMemberId] = useState('charlotte');
  const [editing, setEditing] = useState<FamilyMember | null>(null);
  const [consent, setConsent] = useState<FamilyMember | null>(null);
  const openEdit = (member: FamilyMember) => {
    if (member.canEdit) setEditing(member);else setConsent(member);
  };
  return <main className="bg-white" data-id="element-2101" data-mp="1nzm1mvi4nezy">
      <div className="mx-auto max-w-[1200px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2102" data-mp="1o2rnm1vgm0rg">
        <nav aria-label="Fil d’Ariane" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2103" data-mp="1sxnhl7k9ay77">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-blue" data-id="element-2104" data-mp="2puazjg0k3ha6">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2105" data-mp="2gufkh03vr24v" />
          <span aria-current="page" data-id="element-2106" data-mp="2gskxzhcyn1yo">Ma carte</span>
        </nav>

        <header className="mt-4" data-id="element-2107" data-mp="2bw49un5rgnll">
          <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2108" data-mp="2bv2zkkwkk54x">Ma carte</h1>
          <p className="mt-3 max-w-2xl text-[17px] leading-relaxed text-slate-600" data-id="element-2109" data-mp="26xjcqwlt2k1d">
            Votre carte citoyenne numérique donne accès aux services municipaux pour vous et les membres de votre
            famille.
          </p>
        </header>

        <div className="mt-10 grid gap-10 lg:grid-cols-[minmax(0,460px)_minmax(0,1fr)] lg:gap-14" data-id="element-2110" data-mp="1t5mkmsk50a4z">
          <DigitalCard memberId={memberId} onEdit={openEdit} data-id="element-2111" data-mp="1o607sk880vwp" />
          <div data-id="element-2112" data-mp="1o7l166isu8sz">
            <FamilySection selectedId={memberId} onSelect={setMemberId} data-id="element-2113" data-mp="1j6xdnuts4a3i" />
            <PetsSection data-id="element-2114" data-mp="1j8qir5oqum9e" />
          </div>
        </div>
      </div>

      <AnimatePresence data-id="element-2115" data-mp="19ia0cms92cct">
        {editing && <EditCardDialog member={editing} onClose={() => setEditing(null)} data-id="element-2116" data-mp="19le8fv8u5s8r" />}
      </AnimatePresence>
      <AnimatePresence data-id="element-2117" data-mp="1efrz5kcjzb73">
        {consent && <ConsentDialog member={consent} onClose={() => setConsent(null)} data-id="element-2118" data-mp="10j50nd4yccz2" />}
      </AnimatePresence>
    </main>;
}